/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 *
 * Single resource card. Renders as an <a target="_blank"> so right-click
 * and keyboard navigation work naturally — same effective semantics as
 * window.open(url, '_blank', 'noopener,noreferrer') but more accessible.
 */

import React from 'react';
import { ExternalLink } from 'lucide-react';
import MetaBadge from './MetaBadge';

const TYPE_LABELS = {
  'official-doc': 'Official Doc',
  tool: 'Tool',
  forum: 'Forum',
  cert: 'Certification',
  cheatsheet: 'Cheatsheet',
  video: 'Video',
  book: 'Book',
};

const ResourceCard = ({ resource }) => {
  const typeLabel = TYPE_LABELS[resource.resource_type] || resource.resource_type;

  const onClick = () => {
    // Analytics stub — plug into the real tracker later.
    // eslint-disable-next-line no-console
    console.log('[Resource] click:', resource.title, resource.url);
  };

  return (
    <a
      href={resource.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className="group flex flex-col bg-white border border-brand-border rounded-brandCard p-6 transition-all duration-200 hover:border-brand-cyan hover:-translate-y-0.5 hover:shadow-brand focus:outline-none focus:ring-2 focus:ring-brand-cyan focus:ring-offset-2 no-underline"
    >
      {/* Resource type badge */}
      <div className="mb-4">
        <MetaBadge value={typeLabel} variant="cyan" />
      </div>

      <h3 className="font-bold text-base text-brand-text leading-snug">
        {resource.title}
      </h3>

      {resource.description && (
        <p className="mt-2 text-sm text-brand-muted leading-relaxed line-clamp-3">
          {resource.description}
        </p>
      )}

      <p className="mt-auto pt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-cyan group-hover:translate-x-1 transition-transform">
        Visit
        <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" />
      </p>
    </a>
  );
};

export default ResourceCard;
